import React from 'react'
import { ContentProps, ContentRenderer } from '@components/renderer'
import { usePersonalization } from '@components/variation-container/personalization/use-personalization'
import { usePersonalizationGnarTracking } from '@components/variation-container/personalization/use-personalization-gnar-tracking'
import { SectionThemeProvider } from '@contexts/section-theme-context'
import { useSectionTheme } from '@lib/hooks/use-section-theme'
import { TypeVariationContainerPersonalization } from '@lib/types/variation-container-personalization'

export const PersonalizationVariationContainer: React.FC<ContentProps<TypeVariationContainerPersonalization>> = (
  props
) => {
  const structure = usePersonalization(props.structure)
  const personalizationType = props.structure.fields.internalName
  const variation = structure?.fields.internalName

  // TODO: Improve personalization container resolution https://grammarly.atlassian.net/browse/WEB-446
  // It's important to reassign provider value here, since we can't calculate that in generic section renderer
  // because content is dynamic base on personalization
  const themeValue = useSectionTheme(structure?.fields.background?.color)

  usePersonalizationGnarTracking(personalizationType, variation)

  if (!structure) {
    return null
  }

  return (
    <SectionThemeProvider value={themeValue}>
      <ContentRenderer {...props} structure={structure} />
    </SectionThemeProvider>
  )
}
